<!-- <div class="row m-4">
  <div class="col-md-3">
    <app-navbar></app-navbar>
  </div>
  <div class="col-md-4 mt-3">
    <h1 class="center"><i class="fas fa-address-book"
                          style="margin-right: 6px;color: rgb(202,1,1);font-size: 28px;"></i>Address book <b>Manager</b>
    </h1>

  </div>
</div> -->


<mat-tab-group mat-align-tabs="center">

  <mat-tab label="Customized Phonebook">
            <mat-progress-bar *ngIf=" show_progressbar==true" class="mt-1"
                          mode="query"></mat-progress-bar>

    <div class="row" style="height: 70vh">
      <div class="col-auto">
        <button color="primary" class=" fa-pull-right" (click)="toggle_add_new_phonebook=!toggle_add_new_phonebook"
                mat-icon-button>
          <mat-icon>add</mat-icon>
        </button>
        <button color="primary" class=" fa-pull-right" (click)="get_all_phonebook_files()"
                mat-icon-button>
          <mat-icon>refresh</mat-icon>
        </button>
        <button color="primary" class=" fa-pull-right" (click)="toggle_edit_phonebook=!toggle_edit_phonebook"
                mat-icon-button>
          <mat-icon>edit</mat-icon>
        </button>

        <mat-list class="mt-3">
          <div mat-subheader><h3>Custom Files List</h3></div>
          <mat-divider></mat-divider>
          <mat-list-item *ngFor="let file of list_CustomPhonebookFiles ">
            <mat-icon mat-list-icon>notes</mat-icon>
            <div mat-line (click)="assign_file_row(file)">
              <!--              if edit-->
              <div [hidden]="!toggle_edit_phonebook">
                <button *ngIf="file.Name != 'GeneralPhonebook'" (click)="submit_delete_phonebook_file(file)" color="primary" mat-icon-button>
                  <mat-icon>delete</mat-icon>
                </button>

                <mat-form-field class="example-full-width">
                  <input [disabled]="file.Name == 'GeneralPhonebook'" matInput [id]="'update_id_'+file.Id" [value]="file.Name">
                </mat-form-field>

                <button [disabled]="file.Name == 'GeneralPhonebook'" (click)="submit_edit_phonebook_file(file)" color="primary" mat-icon-button>
                  <mat-icon>save</mat-icon>
                </button>
              </div>
              <!--              no edit-->
              <div *ngIf="!toggle_edit_phonebook">
                <span>{{file.Name}}</span>
                <div *ngIf="file.NoOfEntries >0" mat-line>Entries: {{file.NoOfEntries}} </div>
                <div *ngIf="file.file_path !=null && file.status=='completed'" mat-line><span class="badge badge-pill badge-success">in-service</span></div>
                <div *ngIf="file.status =='new'" mat-line><span class="badge badge-pill badge-warning">task created {{file.created_at | date}}</span></div>
                <div *ngIf="file.status =='processing'" mat-line><span class="badge badge-pill badge-warning"><b>task processing</b></span></div>


              </div>
            </div>
             <button  matTooltip="Publish this phonebook" (click)="publish_phonebook_file(file)" *ngIf="file.file_path ==null && file.status==null"  mat-icon-button ><mat-icon>publish</mat-icon></button>

            <button matTooltip="reload this phonebook" (click)="reload_publish_phonebook_file(file)" *ngIf="file.file_path !==null && file.status=='completed'"  mat-icon-button ><mat-icon>refresh</mat-icon></button>

            <button  matTooltip="delete task phonebook" (click)="delete_publish_phonebook_file(file)" *ngIf="file.status =='new' "  mat-icon-button><mat-icon class="text-danger">cancel</mat-icon></button>
            <button
              [disabled]="file.Name == 'GeneralPhonebook'"
              (click)="toggle_edit_file_mappings=!toggle_edit_file_mappings;selected_phonebook_file=file;
              save_mapping_selected_file=file;
              get_mapped_folders_to_pb_file(file)"
              [hidden]="toggle_edit_phonebook" mat-icon-button color="primary"
              matTooltip="Edit {{file.Name}} assigned folders"
              color="primary"
            >
              <mat-icon>device_hub</mat-icon>
            </button>
            <mat-divider></mat-divider>
          </mat-list-item>
        </mat-list>
      </div>
      <div [hidden]="!toggle_add_new_phonebook" class="ml-3 p-3 col-md-4">
        <div class="row justify-content-start">
          <div class="col-auto">
            <h5>New phonebook file</h5>
          </div>

        </div>
        <mat-divider></mat-divider>
        <div class="row p-3 justify-content-md-start">
          <div class="col-auto">
            <form [formGroup]="form_new_phonebook">
              <mat-form-field class="example-full-width">
                <mat-label>*File Name</mat-label>
                <input matInput formControlName="Name">
              </mat-form-field>
            </form>
            <button (click)="submit_new_phonebook_file()" [disabled]="!form_new_phonebook.valid" color="primary"
                    mat-icon-button>
              <mat-icon>save</mat-icon>
            </button>
          </div>
        </div>


      </div>
      <div class="col-md-auto" [hidden]="!toggle_edit_file_mappings">
        <div class="row mt-3" *ngIf="selected_phonebook_file">
          <h4>Select {{selected_phonebook_file.Name}}'s folder/s</h4>
          <mat-divider></mat-divider>


        </div>
        <div class="row">
          <div class="col">

            <div class="treeview-scroller">
              <mat-list>
                <h5>All Folders</h5>
                <mat-list-item *ngFor="let folder of list_all_phonebook_folders">
                  <mat-icon mat-list-icon>folder</mat-icon>
                  <div mat-line>{{folder.Name}}</div>
                  <div mat-line> Created: {{folder.created_at | date}} </div>
                  <div mat-line> Entries: {{folder.NoOfEntries }}  </div>
                  <button
                    color="primary"
                    mat-icon-button class="pull-right" (click)="receiveMessage2(folder)">
                    <mat-icon>add</mat-icon>
                  </button>
                </mat-list-item>
              </mat-list>
            </div>

          </div>
          <div *ngIf="list_selected_folders.length>0" class="col">
            <div class="treeview-scroller">
              <mat-list>
                <h5>Selected Folders ({{this.list_selected_folders.length}})
                  <button
                    (click)="save_file_folder_mapping()"
                    mat-icon-button color="primary">
                    <mat-icon>save</mat-icon>
                  </button>
                </h5>
                <mat-list-item *ngFor="let folder of list_selected_folders">
                  <mat-icon mat-list-icon>folder</mat-icon>
                  <div mat-line>{{folder.Name}}</div>
                  <div mat-line> Created: {{folder.created_at | date}} </div>
                  <div mat-line> Entries: {{folder.NoOfEntries }}  </div>
                  <button mat-icon-button class="pull-right" color="primary"
                          (click)="delete_folder_from_list(folder)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </mat-list-item>
              </mat-list>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-tab>

  <mat-tab label="Global Phonebook">
    <div class="m-auto  container-fluid">
      <div class="row mb-3">
        <div class="col-2">

          <mat-slide-toggle class="mb-2 " [(ngModel)]="toggle_list">toggle list</mat-slide-toggle>
        </div>
        <div class="col-2">
          <button (click)="get_selected_folder_data() " data-toggle="modal" data-target="#exampleModalLong"
                  *ngIf="selected_item_folder && selected_item_folder['expandable'] ==true" class="w-auto"
                  mat-raised-button>
            <mat-icon>settings</mat-icon>
            {{selected_item_folder['item']}}</button>
        </div>

      </div>
      <div class="row">
        <!--    phonebook list -->
        <div [hidden]="!toggle_list" class="col-md-4">

          <div *ngIf="list_phonebook_files_data!= undefined && list_phonebook_files_data.length==0;else matlistdiv">
            <h5>
              <mat-icon>format_quote</mat-icon>
              No saved files
              <mat-icon>format_quote</mat-icon>
            </h5>
            <mat-divider></mat-divider>
          </div>


          <ng-template class="mt-4" #matlistdiv>


            <!--    phonebook tree-->
            <app-treeview-systems
              title="Address book"
              algorithm="treebyurl"
              parent_icon="contacts"
              child_icon="contact_phone"
              url="http://echuqu013vw.internal.vodafone.com:4800/phonebooktree"
              (messageSelectedFolder)="get_selected_folder($event)"
              (messageEvent2)="get_selected_phonebook_file($event)"
            ></app-treeview-systems>
            <!--    end-->
          </ng-template>
        </div>
        <!--    end-->
        <div [ngClass]="{'col-md-8':toggle_list==true,'col-md-11':toggle_list==false}">
          <div [hidden]="!selected_item_contact"
               [ngClass]="{'col-md-8 w-50  m-auto card border-dark mb-3':toggle_list==true,'col-md-12 w-50 shadow-lg  m-auto card border-dark mb-3':toggle_list==false}">
            <form [formGroup]="form_edit_contact_card">
              <table class="p-4 ">
                <tr>
                  <td>
                    <mat-icon style="font-size: 28px" class="mr-2 text-danger">supervised_user_circle</mat-icon>
                  </td>
                  <td class="mat-headline text-dark">Contact Card</td>
                </tr>
              </table>
              <mat-progress-bar *ngIf=" show_progressbar==true" class="mt-1"
                                mode="query"></mat-progress-bar>
              <hr>
              <div class=" card-header  text-dark">
                <div class="row">
                  <div class="col-6">
                    <table>
                      <tr>
                        <td>
                          <mat-icon class="mr-2">contact_phone</mat-icon>
                        </td>
                        <td><span [hidden]="toggle_edit_form">{{selected_item_contact['Name']}}</span>
                          <mat-form-field [hidden]="!toggle_edit_form" class="example-full-width">
                            <mat-label>Contact Name</mat-label>
                            <input formControlName="Name" matInput [value]="selected_item_contact['Name']">
                          </mat-form-field>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div class="col-6 w-100">
                    <button (click)="toggle_edit_form=!toggle_edit_form;edit_contact_card()" color="primary"
                            class="ml-2 mr-2 fa-pull-right"
                            mat-raised-button>
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button [hidden]="!toggle_edit_form" (click)="delete_form_edit_contact_card();"
                            class=" bg-danger ml-2 mr-2 text-white fa-pull-right" mat-raised-button>
                      <mat-icon>delete_outline</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
              <div class="card-body text-dark ">
                <div class="row w-100">

                </div>

                <table class="w-75 table-hover">
                  <tr>
                    <td>
                      <mat-icon>camera_alt</mat-icon>
                    </td>
                    <td>System type:</td>
                    <td>

                      <span [hidden]="toggle_edit_form">{{selected_item_contact['SystemType']}}</span>


                      <mat-form-field [hidden]="!toggle_edit_form">
                        <mat-label>System Type</mat-label>
                        <mat-select formControlName="SystemType">
                          <mat-option [value]="sys.SystemType" *ngFor="let sys of list_distinct_system_type">
                            {{sys.SystemType}}
                          </mat-option>

                        </mat-select>
                      </mat-form-field>


                    </td>

                  </tr>
                  <tr>
                    <td>
                      <mat-icon>dialer_sip</mat-icon>
                    </td>
                    <td>Protocol:</td>
                    <td><span [hidden]="toggle_edit_form">{{selected_item_contact['Protocol']}}</span>
                      <mat-form-field [hidden]="!toggle_edit_form">
                        <mat-label>Protocol</mat-label>
                        <mat-select formControlName="Protocol">
                          <mat-option value="Auto">
                            Auto
                          </mat-option>
                          <mat-option value="H323">
                            H323
                          </mat-option>
                          <mat-option value="SIP">
                            SIP
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <mat-icon>dialpad</mat-icon>
                    </td>
                    <td>Dial String:</td>
                    <td><span [hidden]="toggle_edit_form">{{selected_item_contact['DialString']}}</span>
                      <mat-form-field [hidden]="!toggle_edit_form" class="example-full-width">
                        <mat-label>Dial String</mat-label>
                        <input formControlName="DialString" matInput [value]="selected_item_contact['DialString']">
                      </mat-form-field>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <mat-icon>call</mat-icon>
                    </td>
                    <td>Call type:</td>
                    <td> {{selected_item_contact['CallType']}}</td>
                  </tr>
                  <tr>
                    <td>
                      <mat-icon>comment</mat-icon>
                    </td>
                    <td> Description:</td>
                    <td>

                      <span [hidden]="toggle_edit_form">{{selected_item_contact['Description']}}</span>
                      <mat-form-field [hidden]="!toggle_edit_form" class="example-full-width">
                        <mat-label>Description</mat-label>
                        <input formControlName="Description" matInput [value]="selected_item_contact['Description']">
                      </mat-form-field>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <mat-icon>warning</mat-icon>
                    </td>
                    <td> Restrict:</td>
                    <td>{{selected_item_contact['Restrict']}}</td>
                  </tr>

                </table>
                <div class="row justify-content-center m-4">
                  <!--            -->
                  <button [disabled]="!form_edit_contact_card.valid" [hidden]="!toggle_edit_form"
                          (click)="show_progressbar=true;submit_form_edit_contact_card()" mat-raised-button
                          color="primary" class="">
                    <mat-icon *ngIf="show_progressbar==false && submit_response==false">save</mat-icon>
                    <i class="fa fa-check text-white" *ngIf="show_progressbar==false && submit_response==true"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </mat-tab>

</mat-tab-group>


<!-- Modal phonebook-->
<div *ngIf="selected_item_folder_row!=undefined" class="modal  fade" id="exampleModalLong" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <mat-icon class="text-dark mr-1" mat-list-icon>settings</mat-icon>
        <h5 class="modal-title" id="exampleModalLabel">
          {{selected_item_folder_row['Name']}} Settings
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div [ngClass]="{'col-7':toggle_edit_catalog,'col-9':!toggle_edit_catalog}">
            <mat-list>

              <mat-list-item>
                <mat-icon mat-list-icon>contacts</mat-icon>
                <div mat-line *ngIf="toggle_edit_catalog==false">{{selected_item_folder_row['Name']}}</div>
                <div mat-line *ngIf="toggle_edit_catalog==true">
                  <form [formGroup]="form_edit_catalog_card">
                    <mat-form-field class="example-full-width">
                      <input matInput formControlName="Name" [value]="selected_item_folder_row['Name']">
                    </mat-form-field>
                  </form>
                </div>
                <div mat-line> Created at: {{selected_item_folder_row['created_at']}} </div>
                <div mat-line> Entries: {{selected_item_folder_row['NoOfEntries']}} </div>
              </mat-list-item>
            </mat-list>

          </div>
          <mat-divider></mat-divider>
          <div [ngClass]="{'button-row col-5':toggle_edit_catalog,'button-row col-3':!toggle_edit_catalog}">
            <button (click)="toggle_edit_catalog=!toggle_edit_catalog" mat-icon-button
                    color="primary"
                    class="fa-pull-right">
              <mat-icon>edit</mat-icon>
            </button>
            <button [disabled]="!form_edit_catalog_card.valid" (click)="submit_form_edit_catalog_card()"
                    [hidden]="!toggle_edit_catalog" mat-icon-button
                    color="primary"
                    class="fa-pull-right">
              <mat-icon>save</mat-icon>
            </button>
            <button [hidden]="!toggle_edit_catalog"
                    (click)="toggle_new_contact_method=!toggle_new_contact_method;edit_new_contact_method()"
                    mat-icon-button
                    color="primary"
                    class="fa-pull-right">
              <mat-icon class="text-success">person_add</mat-icon>
            </button>
            <button [hidden]="!toggle_edit_catalog" (click)="delete_form_edit_catalog_card()" mat-icon-button
                    color="primary"
                    class="fa-pull-right">
              <mat-icon class="text-danger">delete</mat-icon>
            </button>
          </div>
          <mat-divider></mat-divider>
        </div>
        <hr>
        <div [hidden]="!toggle_new_contact_method" class="row p-3">

          <div class="col-auto">
            <h2>New contact method</h2>
            <mat-divider></mat-divider>
            <form style="display: grid" [formGroup]="form_new_contact_method">
              <span>Name</span> <input formControlName="Name" type="text">
              <span>Title</span> <input formControlName="Description" type="text">
              <mat-divider></mat-divider>
              <h4>Contact method</h4>
              <span>Dial String</span> <input formControlName="DialString" type="text">
              <span>System Type</span><select formControlName="SystemType">

              <option [value]="sys.SystemType" *ngFor="let sys of list_distinct_system_type">{{sys.SystemType}}</option>
            </select>
              <span>Protocol</span><select formControlName="Protocol">

              <option value="Auto">Auto</option>
              <option value="H323">H323</option>
              <option value="SIP">SIP</option>
            </select>
              <span>Call Type</span><select formControlName="CallType">

              <option value="Auto">Auto</option>
              <option value="Audio">Audio</option>
              <option value="Video">Video</option>
            </select>

            </form>
            <div class="justify-content-center row">
              <button (click)="submit_form_new_contact_method()" mat-icon-button color="primary">
                <mat-icon>save</mat-icon>
              </button>
            </div>
          </div>

        </div>
      </div>
      <div class="modal-footer">
        <button type="button" mat-raised-button data-dismiss="modal">Close</button>

      </div>
    </div>
  </div>
</div>
